export const STATUS = Object.freeze({
  SUCCESS: 'SUCCESS',
  WARNING: 'WARNING',
  ATTENTION: 'ATTENTION',
  ERROR: 'ERROR',
  DEFAULT: 'DEFAULT',
  NEUTRAL_DARK: 'NEUTRAL_DARK',
  PRIMARY: 'PRIMARY',
});

export const STATUS_COLORS = Object.freeze({
  [STATUS.SUCCESS]: Object.freeze({
    TAG_BG: '!bg-green-400',
    TAG_TEXT: '!text-black',
    TAG_BORDER: '!border-green-400',
    COUNT_BG: '!bg-green-200',
    COUNT_TEXT: '!text-green-600',
    ICON: 'text-green-500',
    CARD_BG: '!bg-green-50',
    CARD_TEXT: '!text-green-600',
    CARD_BORDER: 'border-green-200',
    SUBTEXT: 'text-green-700',
  }),
  [STATUS.WARNING]: Object.freeze({
    TAG_BG: '!bg-yellow-400',
    TAG_TEXT: '!text-black',
    TAG_BORDER: '!border-yellow-400',
    COUNT_BG: '!bg-yellow-200',
    COUNT_TEXT: '!text-yellow-600',
    ICON: 'text-yellow-500',
    CARD_BG: '!bg-yellow-50',
    CARD_TEXT: '!text-yellow-600',
    CARD_BORDER: 'border-yellow-400',
    SUBTEXT: 'text-yellow-700',
  }),
  [STATUS.ATTENTION]: Object.freeze({
    TAG_BG: '!bg-orange-400',
    TAG_TEXT: '!text-black',
    TAG_BORDER: '!border-orange-400',
    COUNT_BG: '!bg-orange-200',
    COUNT_TEXT: '!text-orange-600',
    ICON: 'text-orange-400',
    CARD_BG: '!bg-orange-50',
    CARD_TEXT: '!text-orange-600',
    CARD_BORDER: 'border-orange-400',
    SUBTEXT: 'text-orange-700',
  }),
  [STATUS.ERROR]: Object.freeze({
    TAG_BG: '!bg-red-400',
    TAG_TEXT: '!text-black',
    TAG_BORDER: '!border-red-400',
    COUNT_BG: '!bg-red-200',
    COUNT_TEXT: '!text-red-600',
    ICON: 'text-red-500',
    CARD_BG: '!bg-red-50',
    CARD_TEXT: '!text-red-600',
    CARD_BORDER: 'border-red-300',
    SUBTEXT: 'text-red-700',
  }),
  [STATUS.DEFAULT]: Object.freeze({
    TAG_BG: '!bg-gray-200',
    TAG_TEXT: '!text-gray-600',
    TAG_BORDER: '!border-gray-400',
    COUNT_BG: '!bg-gray-300',
    COUNT_TEXT: '!text-gray-600',
    ICON: 'text-gray-500',
    CARD_BG: '!bg-gray-50',
    CARD_TEXT: '!text-gray-600',
    CARD_BORDER: 'border-gray-300',
    SUBTEXT: 'text-gray-700',
  }),
  [STATUS.NEUTRAL_DARK]: Object.freeze({
    TAG_BG: '!bg-gray-700',
    TAG_TEXT: '!text-white',
    TAG_BORDER: '!border-gray-700',
    COUNT_BG: '!bg-gray-200',
    COUNT_TEXT: '!text-gray-600',
    ICON: 'text-gray-700',
    CARD_BG: '!bg-gray-50',
    CARD_TEXT: '!text-gray-600',
    CARD_BORDER: 'border-gray-800',
    SUBTEXT: 'text-gray-700',
  }),
  [STATUS.PRIMARY]: Object.freeze({
    TAG_BG: '!bg-primary-500',
    TAG_TEXT: '!text-white',
    TAG_BORDER: '!border-primary-500',
    COUNT_BG: '!bg-primary-100',
    COUNT_TEXT: '!text-primary-700',
    ICON: 'text-primary-500',
    CARD_BG: '!bg-primary-50',
    CARD_TEXT: '!text-primary-700',
    CARD_BORDER: 'border-primary-200',
    SUBTEXT: 'text-primary-700',
  }),
});

export const STATUS_ICONS = Object.freeze({
  [STATUS.SUCCESS]: ['far', 'check'],
  [STATUS.WARNING]: ['far', 'hourglass'],
  [STATUS.ATTENTION]: ['far', 'circle-exclamation'],
  [STATUS.ERROR]: ['far', 'triangle-exclamation'],
  [STATUS.DEFAULT]: ['far', 'minus'],
  [STATUS.NEUTRAL_DARK]: ['far', 'xmark'],
  [STATUS.PRIMARY]: ['far', 'info'],
  [STATUS.DIAGONAL]: null,
});

export default STATUS;
